import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  CardBody,
} from "reactstrap"
import { SuccessOk } from "configs/statusCode"
import CardItem from "./CardItem"
import { adminPrefix } from "configs/routePrefix"
import Paginator from "components/Common/Paginator/Paginator"
import RolesService from "services/Admin/RolesService"
import { useSelector } from "react-redux"

const SystemPage = (props) => {
  const service = new RolesService()
  const [active, setActive] = useState("all")
  const [searchWord, setSearchWord] = useState("")
  const [list, setList] = useState([])
  const [shouldGetData, setShouldGetData] = useState(false)
  const [filtersParams, setFilterParams] = useState(null)
  const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  })


  const addHandler = () => {
    props.history.push(`${adminPrefix}/setting/roles/roles-create`)

  }


  const OnSearchChange = (e) => {
    const search = e.target.value
    setSearchWord(search)

  }
  useEffect(() => {
    // debounce solution to reduce request data from api
    const timeoutId = setTimeout(() => {
      const params = {}
      if (active != 'all') params['status'] = active === "active" ? 1 : 0
      if (searchWord.trim().length) params['keyword'] = searchWord
      setFilterParams({ ...params })
    }, 1000)

    return () => clearTimeout(timeoutId)


  }, [active, searchWord])


  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Users Roles</title>
        </MetaTags>
        <Container fluid >
          <Row className="mb-1">
            <Col md={6}>
              <h4>Manage Users Roles</h4>
             </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="form-group has-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input type="text" className="form-control" placeholder="Search by user role name, I.D" onChange={(e) => OnSearchChange(e)}
                  value={searchWord} />
              </div>
            </Col>
            {isExist("role.add") ?<Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                <button className="btn btn-success btnHeight px-4" onClick={addHandler}>Add New Role</button>
              </div>
            </Col>:null}
          </Row>
          <Row className="my-4" >
            <Col sm={6} className="mb-3">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("all")
                }}
              >
                All
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "active" ? "#556ee6" : "#f4f4f4",
                  color: active == "active" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("active")
                }}
              >
                Active
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                  color: active == "deactive" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("deactive")
                }}
              >
                Deactive
                            </button>
            </Col>
          </Row>
          <div>
            <Card className="w-100 mt-4">
              <CardBody>
                <div className='py-3'>
                  <div>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            <th className='font-size-16'>I.D</th>
                            <th className='font-size-16'>Name</th>
                            <th className='font-size-16'>No. of users </th>
                            <th className='font-size-16'>Status</th>
                            <th className='font-size-16'></th>

                          </tr>
                        </thead>
                        <tbody>

                          {list.map((item, index) => <CardItem
                            key={index}
                            index={index}
                            {...item}
                            item={item}
                            Service={RolesService}
                            history={props.history}
                            setShouldGetData={setShouldGetData}
                          />)}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-end" md={8} sm={12}>
                <Paginator
                  service={service}
                  pageOptions={pageOptions}
                  setData={(data) => setList([...data])}
                  setPageOptions={setPageOptions}
                  filtersParams={filtersParams}
                  shouldGetData={shouldGetData}
                  setShouldGetData={setShouldGetData}
                />
              </Col>
            </Row>
          </div>

        </Container>
      </div>
    </React.Fragment>
  )
}

export default SystemPage
